(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asaanliving-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let announcement;
    const positionAnnouncement = (event) => {
      const bar = event?.target?.querySelector?.('[data-al-delivery-announcement]') || document.querySelector('[data-al-delivery-announcement]');
      announcement = bar?.closest('.shopify-section') || announcement;
      const header = document.querySelector('#shopify__header__section > .header_bottom');
      if (announcement && header && announcement.parentElement !== header) {
        header.appendChild(announcement);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', positionAnnouncement, { once: true });
    } else {
      positionAnnouncement();
    }
    document.addEventListener('shopify:section:load', positionAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asaanliving-featured-picks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('al-featured-picks')) {
 customElements.define('al-featured-picks', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   this.events = new AbortController();
   this.querySelectorAll('[data-pick-filter]').forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.pickFilter;
    this.querySelectorAll('[data-pick-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    this.querySelectorAll('[data-pick-category]').forEach(card => { card.hidden = category !== 'all' && card.dataset.pickCategory !== category; });
   }, {signal:this.events.signal}));
  }
  disconnectedCallback() { this.events?.abort(); this.bound = false; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asaanliving-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('al-hero-carousel')) {
  customElements.define('al-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.current = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(max-width: 749px)').matches;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      if (this.slides.length < 2) return;
      this.querySelector('.al-carousel-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => { this.show(this.current - 1); this.start(); }, options);
      this.querySelector('[data-next]').addEventListener('click', () => { this.show(this.current + 1); this.start(); }, options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.start(); }, options));
      this.querySelector('[data-pause]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.updatePause();
        this.start();
      }, options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
          this.start();
        }
      }, options);
      this.updatePause();
      this.start();
    }
    show(index) {
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? 'Play cover rotation' : 'Pause cover rotation');
      button.firstElementChild.textContent = this.paused ? '\u25b7' : '\u275a\u275a';
    }
    stop() { window.clearInterval(this.timer); }
    start() {
      this.stop();
      if (!this.paused && !document.hidden) {
        this.timer = window.setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 6500);
      }
    }
    disconnectedCallback() { this.stop(); this.events?.abort(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asaanliving-product-demos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('al-product-demos')) {
  customElements.define('al-product-demos', class extends HTMLElement {
    connectedCallback() {
      if (this.demoEvents) return;
      this.demoEvents = new AbortController();
      const videos = [...this.querySelectorAll('video')];
      const loadPoster = video => {
        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          delete video.dataset.poster;
        }
      };
      if ('IntersectionObserver' in window) {
        this.posterObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              loadPoster(entry.target);
              this.posterObserver.unobserve(entry.target);
            }
          });
        }, {rootMargin: '300px 0px'});
        videos.forEach(video => this.posterObserver.observe(video));
      } else {
        videos.forEach(loadPoster);
      }
      videos.forEach(video => video.addEventListener('play', () => {
        loadPoster(video);
        videos.forEach(other => { if (other !== video) other.pause(); });
      }, {signal:this.demoEvents.signal}));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach(video => video.pause());
      }, {signal:this.demoEvents.signal});
      this.demoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); });
      });
      videos.forEach(video => this.demoObserver.observe(video));
    }
    disconnectedCallback() {
      this.demoEvents?.abort();
      this.demoObserver?.disconnect();
      this.posterObserver?.disconnect();
      this.demoEvents = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function showAsaanLivingCommentConfirmation() {
  if (window.location.hash !== '#comment-submitted') return;
  const confirmation = document.getElementById('comment-submitted');
  if (!confirmation) return;
  confirmation.hidden = false;
  confirmation.focus({ preventScroll: true });
  confirmation.scrollIntoView({ block: 'center' });
  const notificationWebhook = confirmation.dataset.notificationWebhook;
  const articleId = confirmation.dataset.articleId;
  if (notificationWebhook && articleId) {
    fetch(notificationWebhook, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ article_id: articleId }),
      keepalive: true
    }).catch(() => {});
  }
  const cleanUrl = new URL(window.location.href);
  cleanUrl.searchParams.delete('comment');
  cleanUrl.hash = 'comments';
  window.history.replaceState(window.history.state, '', cleanUrl);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', showAsaanLivingCommentConfirmation, { once: true });
} else {
  showAsaanLivingCommentConfirmation();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
  }

  const couponCodeField = document.getElementById('coupon_code_cart');
  if (couponCodeField) {
    couponCodeField.value = localStorage.getItem('coupon') || '';
  }

  } catch(e) { console.error(e); }
})();
})();
